module.exports = __webpack_public_path__ + "img/bg.0029a41f.jpeg";